import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectOption } from '@app/interfaces/sys/dict';
import { QueryTaskParams, Task } from '@app/interfaces/lm/kanban-board';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountService } from '@services/sys/account.service';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { is } from 'date-fns/locale';

@Component({
    selector: 'app-add-task-link',
    templateUrl: './add-task-link.component.html',
    styleUrl: './add-task-link.component.less',
})
export class AddTaskLinkComponent {
    @Input() projectId!: string;
    @Input() taskDetail!: Task;
    @Output() submitSuccess = new EventEmitter();

    validateForm!: FormGroup;
    autoTips: Record<string, Record<string, string>> = {
        default: {
            required: 'Input is required',
        },
    };
    isVisible = false;
    submitLoading = false;
    taskLoading = false;
    pageIndex = 0;
    pageSize = 10;
    linkSearchTaskCount = 0;
    linkSearchKeyword = '';
    loadTaskOptions: Task[] = [];   // 全部的task用于处理分页停止的判断
    linkTaskTimer: number | null = null;
    linkedTasksIds: string[] = [];

    constructor(private accountService: AccountService,
                private fb: FormBuilder,
                private message: NzMessageService,
                private kanbanBoardService: KanbanBoardService,
    ) {
    }

    async open(): Promise<void> {
        this.isVisible = true;
        this.validateForm = this.fb.group({
            taskIds: [[], [Validators.required]],
        });
        const linkedTasks = this.taskDetail.linkedTasks || [];
        this.linkedTasksIds = linkedTasks.map(it => it.id);
    }

    async loadTask(): Promise<void> {
        if (this.loadTaskOptions.length >= this.linkSearchTaskCount || this.taskLoading) {
            return ;
        }
        this.pageIndex += 1;
        await this.getLinkTask(false);
    }

    clearLinkTimer(): void {
        if (this.linkTaskTimer) {
            clearTimeout(this.linkTaskTimer);
            this.linkTaskTimer = null;
        }
    }

    searchLinkTask(value: string): void {
        this.pageIndex = 0;
        this.clearLinkTimer();
        this.linkSearchKeyword = value;
        this.linkTaskTimer = window.setTimeout(async () => {
            await this.getLinkTask(true);
        }, 350);
    }

    async getLinkTask(init: boolean = false): Promise<void> {
        try {
            console.log('init', init);
            if (init) {
                this.loadTaskOptions = [];
            }
            this.taskLoading = true;
            const params = {
                startRow: init ? 0 : this.pageIndex * this.pageSize + 1,
                endRow: init ? this.pageSize : (this.pageIndex + 1) * this.pageSize,
            };
            const allTasks = await this.getProjectTasks(params);
            if (init) {
                const { count } = this.kanbanBoardService.extractUniqueCounts(allTasks);
                this.loadTaskOptions = [...allTasks];
                this.linkSearchTaskCount = count;
            } else {
                this.loadTaskOptions.push(...allTasks);
            }
        } finally {
            this.taskLoading = false;
        }
    }

    async getProjectTasks(otherParams: QueryTaskParams): Promise<Task[]> {
        const params = {
            projectId: this.projectId,
            isDESC: true,
            ...otherParams,
            keyword: this.linkSearchKeyword
        };
        const projectTasks = await this.kanbanBoardService.loadAllTasks(params);
        return projectTasks;
    }

    close(): void {
        this.isVisible = false;
    }

    validForm(): boolean {
        for (const control of Object.values(this.validateForm.controls)) {
            control.markAsDirty();
            control.updateValueAndValidity();
        }
        if (!this.validateForm.valid) {
            return false;
        }

        return true;
    }

    async onSubmit(): Promise<void> {
        try {
            if (!this.validForm()) {
                return;
            }
            const { taskIds } = this.validateForm.value;
            this.submitLoading = true;
            const linkedTasks = this.taskDetail.linkedTasks || [];
            const data = {
                taskId: this.taskDetail.taskId,
                linkedTaskIds: [...linkedTasks.map(it => it.id), ...taskIds],
            };
            await this.kanbanBoardService.updateTaskLinkedTask(data);
            this.message.success('Added  successfully');
            this.close();
            this.submitSuccess.emit();
        } finally {
            this.submitLoading = false;
        }
    }
}
